export enum OnboardingTours {
    INITIAL = 'initial',
    PRODUCT_CONFIGURATION = 'product-configuration',
    ROUTE = 'route',
    ROUTE_ITEM = 'route-item',
    CAPACITY = 'capacity',
    SCHEDULE = 'schedule',
    PRICING = 'pricing',
    OPTION = 'option',
    PREVIEW = 'preview',
    PRODUCT_LIST = 'product-list',
    BOOKING_CREATION = 'booking-creation',
}

export enum OnboardingClasses {
    WORKSPACE_TAG = 'workspace-tag',
    CREATE_PRODUCT_BUTTON = 'create-product-button',
    GROUP_TOUR_TOGGLE = 'group-tour-toggle',
    AUTOSCALE_TOGGLE = 'autoscale-toggle',
    ADD_ROUTE_BUTTON = 'add-route-button',
    FIRST_ROUTE_NAME = 'first-route-name',
    FIRST_ROUTE_ROUND_TRIP = 'first-route-round-trip',
    FIRST_ROUTE_ARRIVAL = 'first-route-arrival',
    FIRST_ROUTE_DURATION = 'first-route-duration',
    FIRST_ROUTE_ACTIONS = 'first-route-actions',
    ROUTE_CARDS = 'route-cards',

    CAPACITY_CARDS = 'capacity-cards',
    ADD_CAPACITY_OPTION = 'add-capacity-option',
    CAPACITY_TYPES_DROPDOWN = 'capacity-types-dropdown',
    CAPACITY_NAME = 'capacity-name',
    CAPACITY_CONTROL_PANEL = 'capacity-control-panel',

    SCHEDULE_AREA = 'schedule-area',
    DURATION = 'duration',
    POTENTIAL_OVERTIME = 'potential-overtime',
    ADD_SCHEDULE_ITEM = 'add-schedule-item',

    ADD_PRICE_BUTTON = 'add-price-button',
    PER_PERSON_CARD = 'per-person-card',
    INCLUSIONS = 'inclusions',
    DEPENDENCIES = 'dependencies',
    PRICING_CARDS = 'pricing-cards',
    PAYMENT_METHODS = 'payment-methods',
    PREPAYMENT = 'prepayment',

    OPTIONS_CARDS = 'options-cards',
    ADD_OPTION_BUTTON = 'add-option-button',
    OPTION_CARD = 'option-card',

    PRODUCT_CARD = 'product-card',
    CONTROL_PANEL = 'control-panel',
    PREVIEW_ICON = 'preview-icon',
    PRODUCT_PREVIEW_PANEL = 'product-preview-panel',
    DUPLICATE_BUTTON = 'duplicate-button',
    DELETE_BUTTON = 'delete-button',

    CREATE_BOOKING_BUTTON = 'create-booking-button',
    CREATE_BOOKING_MODAL = 'create-booking-modal',
    CHECK_AVAILABILITY_BUTTON = 'check-availability-button',
    AVAILABILITY_CALENDAR = 'availability-calendar',
    SEE_ALL_PRODUCTS_LINK = 'see-all-products-link',
    EXPANDED_VIEW = 'expanded-view',
    FIRST_TIME_SLOT = 'first-time-slot',
    BOOKING_PREVIEW = 'booking-preview',
    SAVE_AS_DRAFT_BUTTON = 'save-as-draft-button',
    CONFIRM_BUTTON = 'confirm-button',
    ORDER_MENU = 'order-menu',
    DAILY_VIEW_MENU = 'daily-view-menu',
}
